; (function ($) {
    var Caroursel = function (caroursel) {
        var self = this;
        this.caroursel = caroursel;
        this.posterList = caroursel.find(".poster-list");
        this.posterItems = caroursel.find(".poster-item");
        this.firstPosterItem = this.posterItems.first();
        this.lastPosterItem = this.posterItems.last();
        this.prevBtn = this.caroursel.find(".poster-prev-btn");
        this.nextBtn = this.caroursel.find(".poster-next-btn");

        this.firstBtn = this.caroursel.find(".poster-first-btn");
        this.secondBtn = this.caroursel.find(".poster-second-btn");
        this.thirdBtn = this.caroursel.find(".poster-third-btn");
        this.buttonItems = [this.firstBtn, this.secondBtn, this.thirdBtn];

        //每个移动元素的位置索引,用于记录每个元素当前的位置,在每次移动的时候,该数组的值都会发生变化
        //值为1 表示在中间 2:在zuo边 3:在you边 4zuo边 5右边  6左边  7右边
        //数组的下标对应li元素的位置索引
        this.curPositions = [1, 2, 3, 4, 5, 6, 7];

        this.setting = {
            "width": "1060",
            "height": "300",
            "posterWidth": "543",
            "posterHeight": "297",
            "scale": "0.9",
            "speed": "1000",
            "dealy": "2000",
        };

        $.extend(this.setting, this.getSetting());

        this.setFirstPosition();

        this.setSlicePosition();

        this.refreshCss();

        this.rotateFlag = true;
        this.prevBtn.bind("click", function () {
            if (self.rotateFlag) {
                self.rotateFlag = false;
                self.rotateAnimate("left")
            }
        });


        //绑定位置按钮事件
        this.firstBtn.bind("click", function () {
            console.log(this);
            self.clickPosButtonIndex(0);
        });
        this.secondBtn.bind("click", function () {
            self.clickPosButtonIndex(1);
        });
        this.thirdBtn.bind("click", function () {
            self.clickPosButtonIndex(2);
        });


        this.nextBtn.bind("click", function () {
            if (self.rotateFlag) {
                self.rotateFlag = false;
                self.rotateAnimate("right")
            }
        });
        if (this.setting.isAutoplay) {
            this.autoPlay();
            this.caroursel.hover(function () { clearInterval(self.timer) }, function () { self.autoPlay() })
        }
    };
    Caroursel.prototype = {
        autoPlay: function () {
            var that = this;
            this.timer = window.setInterval(function () {
                that.nextBtn.click();
            }, that.setting.dealy)
        },


        refreshCss: function () {
            var curFirstPos;//当前位于中间的li元素位置
            for (i = 0; i < this.buttonItems.length; ++i) {
                var curButton = this.buttonItems[i];
                var curPos = this.curPositions[i];
                if (curPos == 1) {
                    curButton.addClass('poster-btn-active');
                }
                else {
                    curButton.removeClass('poster-btn-active');
                }
            }
            console.log('after refresh claass');
        },

        //记录每次移动的状态
        refreshPositions: function (offset) {
            console.log('before refreshPositions', this.curPositions);
            for (i = 0; i < this.curPositions.length; ++i) {
                var nextPos = this.curPositions[i] + offset;
                if (nextPos > this.curPositions.length) {//移动超过末尾,则位置变成到开头
                    nextPos = 1;
                } else
                    if (nextPos < 1) {////向左边移动已经移动到开始位置更左边,则位置变成结束
                        nextPos = this.curPositions.length;
                    }
                this.curPositions[i] = nextPos;
            }
            console.log('after refreshPositions', this.curPositions);
            this.refreshCss();
        },
        //点击位置按钮,根据点击的按钮索引 决定向左还是向右移动[因为只有三个位置,该方法能够仅靠向左或向右就能将
        //指定的位置移动到中间]
        clickPosButtonIndex: function (index) {
            console.log('click the index ' + index);
            var self = this;
            if (self.rotateFlag == false) {//目前正在移动等移动结束后才能进入
                return;
            }

            var curPos = this.curPositions[index];
            console.log('cur pos' + curPos);

            var moveDirection = null;
            if (curPos == 2) {//目标位置现在 在zuo边,要移动到中间 只需要向左边移动一次
                moveDirection = "right";
            } else
                if (curPos == 3) {//目标位置现在在you边,向右边移动一次
                    moveDirection = "left";
                }

            if (moveDirection != null) {
                console.log('move to ' + moveDirection);
                self.rotateFlag = false;
                self.rotateAnimate(moveDirection)
            }
        },

        rotateAnimate: function (type) {
            var that = this;
            var zIndexArr = [];
            if (type == "left") {//将posterItems的每个元素移动到下一个元素所在的位置
                this.posterItems.each(function () {
                    var self = $(this),
                        prev = $(this).next().get(0) ? $(this).next() : that.firstPosterItem,
                        width = prev.css("width"),
                        height = prev.css("height"),
                        zIndex = prev.css("zIndex"),
                        opacity = prev.css("opacity"),
                        left = prev.css("left"),
                        top = prev.css("top");
                    zIndexArr.push(zIndex);
                    self.animate({
                        "width": width,
                        "height": height,
                        "left": left,
                        "opacity": opacity,
                        "top": top
                    }, that.setting.speed, function () {
                        that.rotateFlag = true;
                    });
                });
                this.posterItems.each(function (i) {
                    $(this).css("zIndex", zIndexArr[i]);
                });
                this.refreshPositions(1);
            }
            if (type == "right") {////将posterItems的每个元素移动到下上一个元素所在的位置
                this.posterItems.each(function () {
                    var self = $(this),
                        next = $(this).prev().get(0) ? $(this).prev() : that.lastPosterItem,
                        width = next.css("width"),
                        height = next.css("height"),
                        zIndex = next.css("zIndex"),
                        opacity = next.css("opacity"),
                        left = next.css("left"),
                        top = next.css("top");
                    zIndexArr.push(zIndex);
                    self.animate({
                        "width": width,
                        "height": height,
                        "left": left,
                        "opacity": opacity,
                        "top": top
                    }, that.setting.speed, function () {
                        that.rotateFlag = true;
                    });
                });
                this.posterItems.each(function (i) {
                    $(this).css("zIndex", zIndexArr[i]);
                });
                this.refreshPositions(-1);
            }
        },
        setFirstPosition: function () {
            this.caroursel.css({ "width": this.setting.width, "height": this.setting.height });
            this.posterList.css({ "width": this.setting.width, "height": this.setting.height });
            var width = (this.setting.width - this.setting.posterWidth) / 2;

            this.prevBtn.css({ "width": width, "height": this.setting.height, "zIndex": Math.ceil(this.posterItems.size() / 2) });
            this.nextBtn.css({ "width": width, "height": this.setting.height, "zIndex": Math.ceil(this.posterItems.size() / 2) });
            console.log(this.posterItems.size, '1111');
            this.firstPosterItem.css({
                "width": this.setting.posterWidth,
                "height": this.setting.posterHeight,
                "left": width,
                "zIndex": Math.ceil(this.posterItems.size() / 2),
                "top": this.setVertialType(this.setting.posterHeight)
            });
        },
        setSlicePosition: function () {
            var _self = this;
            var sliceItems = this.posterItems.slice(1),
                level = Math.floor(this.posterItems.length / 2),
                leftItems = sliceItems.slice(0, level),
                rightItems = sliceItems.slice(level),
                posterWidth = this.setting.posterWidth,
                posterHeight = this.setting.posterHeight,
                Btnwidth = (this.setting.width - this.setting.posterWidth) / 2,
                gap = Btnwidth / level,
                containerWidth = this.setting.width;

            var i = 1;
            var leftWidth = posterWidth;
            var leftHeight = posterHeight;
            var zLoop1 = level;
            leftItems.each(function (index, item) {
                leftWidth = posterWidth * _self.setting.scale;
                leftHeight = posterHeight * _self.setting.scale;
                $(this).css({
                    "width": leftWidth,
                    "height": leftHeight,
                    "left": Btnwidth - i * gap,
                    "zIndex": zLoop1--,
                    "opacity": 1 / (i + 1),
                    "top": _self.setVertialType(leftHeight)
                });
                i++;
            });

            var j = level;
            var zLoop2 = 1;
            var rightWidth = posterWidth;
            var rightHeight = posterHeight;
            rightItems.each(function (index, item) {
                var rightWidth = posterWidth * _self.setting.scale;
                var rightHeight = posterHeight * _self.setting.scale;
                $(this).css({
                    "width": rightWidth,
                    "height": rightHeight,
                    "left": containerWidth - (Btnwidth - j * gap + rightWidth),
                    "zIndex": zLoop2++,
                    "opacity": 1 / (j + 1),
                    "top": _self.setVertialType(rightHeight)
                });
                j--;
            });
        },
        getSetting: function () {
            var settting = this.caroursel.attr("data-setting");
            if (settting.length > 0) {
                return $.parseJSON(settting);
            } else {
                return {};
            }
        },
        setVertialType: function (height) {
            var algin = this.setting.algin;
            if (algin == "top") {
                return 0
            } else if (algin == "middle") {
                return (this.setting.posterHeight - height) / 2
            } else if (algin == "bottom") {
                return this.setting.posterHeight - height
            } else {
                return (this.setting.posterHeight - height) / 2
            }
        }
    };
    Caroursel.init = function (caroursels) {
        caroursels.each(function (index, item) {
            new Caroursel($(this));
        });
    };
    window["Caroursel"] = Caroursel;
})(jQuery);